import { render, staticRenderFns } from "./Votacao.vue?vue&type=template&id=4ad371bb&scoped=true"
import script from "./Votacao.vue?vue&type=script&lang=js"
export * from "./Votacao.vue?vue&type=script&lang=js"
import style0 from "./Votacao.vue?vue&type=style&index=0&id=4ad371bb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ad371bb",
  null
  
)

export default component.exports